var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBeneficiarioIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#707070;}.b{clip-path:url(#a);}.c{fill:none;}.d{fill:#5a5a5a;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 20,
    height: 20,
    transform: "translate(5 5)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(-5 -5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,0H20V20H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M7.5,11.458c-1.95,0-5.833.975-5.833,2.917v1.458H13.333V14.375C13.333,12.433,9.45,11.458,7.5,11.458ZM3.617,14.167A8.035,8.035,0,0,1,7.5,13.125a8.035,8.035,0,0,1,3.883,1.042ZM7.5,10A2.917,2.917,0,1,0,4.583,7.083,2.92,2.92,0,0,0,7.5,10Zm0-4.167a1.25,1.25,0,1,1-1.25,1.25A1.248,1.248,0,0,1,7.5,5.833Zm5.867,5.675A3.494,3.494,0,0,1,15,14.375v1.458h3.333V14.375C18.333,12.692,15.417,11.733,13.367,11.508ZM12.5,10a2.917,2.917,0,0,0,0-5.833,2.871,2.871,0,0,0-1.25.292,4.551,4.551,0,0,1,0,5.25A2.871,2.871,0,0,0,12.5,10Z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBeneficiarioIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/beneficiarioIcon.45b14d8d.svg";
export { ForwardRef as ReactComponent };